(function () {
  if (window.__janineGiftsLoaded) return;
  window.__janineGiftsLoaded = true;
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observer = null;

  function initReveals(scope) {
    var reveals = scope.querySelectorAll('[data-jg-reveal]');
    if (reducedMotion || !('IntersectionObserver' in window)) {
      reveals.forEach(function (element) { element.classList.add('is-visible'); });
      return;
    }
    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    }
    reveals.forEach(function (element) { observer.observe(element); });
  }

  function initCarousels(scope) {
    scope.querySelectorAll('[data-jg-carousel]').forEach(function (carousel) {
      if (carousel.dataset.jgReady === 'true') return;
      carousel.dataset.jgReady = 'true';
      var track = carousel.querySelector('.jg-product-track');
      var previous = carousel.querySelector('[data-jg-direction="-1"]');
      var next = carousel.querySelector('[data-jg-direction="1"]');
      if (!track || !previous || !next) return;

      function update() {
        if (window.matchMedia('(max-width:749px)').matches) {
          var image = track.querySelector('.jg-product__image');
          if (image) carousel.style.setProperty('--jg-mobile-image-height', image.offsetHeight + 'px');
        }
        var max = Math.max(0, track.scrollWidth - track.clientWidth);
        var x = Math.abs(track.scrollLeft);
        previous.disabled = max < 2 || x < 2;
        next.disabled = max < 2 || x >= max - 2;
      }

      function move(direction) {
        var card = track.querySelector('.jg-product');
        if (!card) return;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        track.scrollBy({
          left: direction * (card.getBoundingClientRect().width + gap),
          behavior: reducedMotion ? 'auto' : 'smooth'
        });
      }

      carousel.addEventListener('click', function (event) {
        var button = event.target.closest('[data-jg-direction]');
        if (button) move(Number(button.dataset.jgDirection));
      });
      track.addEventListener('scroll', update, { passive: true });
      track.addEventListener('keydown', function (event) {
        if (event.target !== track) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          move(event.key === 'ArrowRight' ? 1 : -1);
        }
      });
      carousel.addEventListener('shopify:block:select', function (event) {
        var card = event.target.closest('.jg-product');
        if (card) track.scrollTo({ left: card.offsetLeft - track.offsetLeft, behavior: 'auto' });
      });
      if ('ResizeObserver' in window) {
        var resizeObserver = new ResizeObserver(update);
        resizeObserver.observe(track);
        track.querySelectorAll('.jg-product__image').forEach(function (image) { resizeObserver.observe(image); });
      }
      update();
    });
  }

  initReveals(document);
  initCarousels(document);
  document.addEventListener('shopify:section:load', function (event) {
    initReveals(event.target);
    initCarousels(event.target);
  });
})();
